import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import helper from "@/utils/helper";

const routes = [
    {
        path: "/",
        redirect: "/home",
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("../views/LoginView.vue"),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/recovery_password",
        name: "PasswordRecovery",
        component: () => import("../views/PasswordRecoveryView.vue"),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/reset-password/:token",
        name: "PasswordReset",
        component: () => import("../views/PasswordResetView.vue"),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/home",
        name: "Home",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/HomeView.vue"),
        meta: {
            requiresAuth: true,
            breadCrumb() {
                return [
                    {
                        label: "Главная",
                    },
                ];
            },
        },
    },
    {
        path: "/gender/:gender_type",
        name: "Sportsmen",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/SportsmenView"),
        meta: {
            requiresAuth: true,
            breadCrumb(route) {
                const gender_type =
                    route.params.gender_type === "men" ? "Мужчины" : "Женщины";
                return [
                    {
                        label: "Главная",
                        to: { name: "Home" },
                    },
                    {
                        label: `${gender_type}`,
                    },
                ];
            },
        },
    },
    {
        path: "/gender/:gender_type/sportsman/:id/:fio",
        name: "SportsmanProfile",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/SportsmanProfileView"
            ),
        meta: {
            requiresAuth: true,
            breadCrumb(route) {
                const gender_type =
                    route.params.gender_type === "men" ? "Мужчины" : "Женщины";
                const fio = helper.getDecodeString(route.params.fio);
                return [
                    {
                        label: "Главная",
                        to: { name: "Home" },
                    },
                    {
                        label: `${gender_type}`,
                        to: { path: `/gender/${route.params.gender_type}` },
                    },
                    {
                        label: `${fio}`,
                    },
                ];
            },
        },
    },
    {
        path: "/facilities",
        name: "Facilities",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/FacilitiesView"),
        meta: {
            requiresAuth: true,
            breadCrumb() {
                return [
                    {
                        label: "Главная",
                        to: { name: "Home" },
                    },
                    {
                        label: "Справочники. Льготы",
                    },
                ];
            },
        },
    },
    {
        path: "/settlements",
        redirect: "/settlements/settlements_main",
        name: "Settlements",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/SettlementsView"),
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "settlements_main",
                name: "SettlementsMain",
                component: () =>
                    import(
                        /* webpackChunkName: "about" */ "../components/Pages/Settlements/TabContent/SettlementsMain"
                    ),
                meta: {
                    requiresAuth: true,
                    breadCrumb() {
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Справочники. Населенные пункты",
                            },
                        ];
                    },
                },
            },
            {
                path: "settlements_types",
                name: "SettlementsTypes",
                component: () =>
                    import(
                        /* webpackChunkName: "about" */ "../components/Pages/Settlements/TabContent/SettlementsTypes"
                    ),
                meta: {
                    requiresAuth: true,
                    breadCrumb() {
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Справочники. Типы населенных пунктов",
                            },
                        ];
                    },
                },
            },
        ],
    },
    {
        path: "/subjects",
        redirect: "/subjects/subjects_main",
        name: "Subjects",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/SubjectsView"),
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "subjects_main",
                name: "SubjectsMain",
                component: () =>
                    import(
                        /* webpackChunkName: "about" */ "../components/Pages/Subjects/TabContent/SubjectsMain"
                    ),
                meta: {
                    requiresAuth: true,
                    breadCrumb() {
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Справочники. Субъекты РФ",
                            },
                        ];
                    },
                },
            },
            {
                path: "subjects_types",
                name: "SubjectsTypes",
                component: () =>
                    import(
                        /* webpackChunkName: "about" */ "../components/Pages/Subjects/TabContent/SubjectsTypes"
                    ),
                meta: {
                    requiresAuth: true,
                    breadCrumb() {
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Справочники. Типы субъектов РФ",
                            },
                        ];
                    },
                },
            },
        ],
    },
    {
        path: "/federal_district",
        name: "FederalDistrict",
        component: () =>
            import(
                /* webpackChunkName: "about" */ "../views/FederalDistrictView"
            ),
        meta: {
            requiresAuth: true,
            breadCrumb() {
                return [
                    {
                        label: "Главная",
                        to: { name: "Home" },
                    },
                    {
                        label: "Справочники. Федеральные округа",
                    },
                ];
            },
        },
    },
    {
        path: "/countries",
        name: "Countries",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/CountriesView"),
        meta: {
            requiresAuth: true,
            breadCrumb() {
                return [
                    {
                        label: "Главная",
                        to: { name: "Home" },
                    },
                    {
                        label: "Справочники. Страны",
                    },
                ];
            },
        },
    },
    {
        path: "/judges",
        redirect: "/judges/judges_main",
        name: "Judges",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/JudgesView"),
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "judges_main",
                name: "JudgesMain",
                component: () =>
                    import(
                        /* webpackChunkName: "about" */ "../components/Pages/Judges/TabContent/JudgesMain"
                    ),
                meta: {
                    requiresAuth: true,
                    breadCrumb() {
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Справочники. Судьи",
                            },
                        ];
                    },
                },
            },
            {
                path: "judges_categories",
                name: "JudgesCategories",
                component: () =>
                    import(
                        /* webpackChunkName: "about" */ "../components/Pages/Judges/TabContent/JudgesCategories"
                    ),
                meta: {
                    requiresAuth: true,
                    breadCrumb() {
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Справочники. Категории судей",
                            },
                        ];
                    },
                },
            },
        ],
    },
    {
        path: "/options",
        name: "Options",
        redirect: "/options/payment",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/OptionsView"),
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "payment",
                name: "Payment",
                component: () =>
                    import(
                        /* webpackChunkName: "about" */ "../components/Pages/Options/TabContent/OptionPayment"
                    ),
                meta: {
                    requiresAuth: true,
                    breadCrumb() {
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Параметры. Оплата",
                            },
                        ];
                    },
                },
            },
            {
                path: "bonus_score",
                name: "BonusScore",
                component: () =>
                    import(
                        /* webpackChunkName: "about" */ "../components/Pages/Options/TabContent/OptionBonusScore"
                    ),
                meta: {
                    requiresAuth: true,
                    breadCrumb() {
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Параметры. Бонусные очки",
                            },
                        ];
                    },
                },
            },
        ],
    },
    {
        path: "/service",
        redirect: "/service/player-merges",
    },
    {
        path: "/service/player-duplicates",
        name: "PlayerDuplicates",
        component: () => import("../views/PlayerDuplicatesView.vue"),
        meta: {
            requiresAuth: true,
            breadCrumb: () => [
                { label: "Главная", to: { name: "Home" } },
                { label: "Сервис" },
                { label: "Поиск дублей игроков" },
            ],
        },
    },
    ...[
        {
            path: "/service/player-merges",
            name: "PlayerMerges",
            journal: "merges",
            title: "Слияния игроков",
        },
        {
            path: "/service/recalculations",
            name: "RatingRecalculations",
            journal: "recalculations",
            title: "Пересчёты рейтинга",
        },
    ].map(({ path, name, journal, title }) => ({
        path,
        name,
        component: () => import("../views/ServiceJournalView.vue"),
        props: { journal },
        meta: {
            requiresAuth: true,
            breadCrumb: () => [
                { label: "Главная", to: { name: "Home" } },
                { label: "Сервис" },
                { label: title },
            ],
        },
    })),
    {
        path: "/tournaments",
        name: "TournamentsList",
        component: () => import("../views/TournamentsListView.vue"),
        meta: {
            requiresAuth: true,
            breadCrumb() {
                return [
                    {
                        label: "Главная",
                        to: { name: "Home" },
                    },
                    {
                        label: "Соревнования",
                    },
                ];
            },
        },
    },
    {
        path: "/tournament",
        name: "TournamentView",
        component: () => import("../views/TournamentView.vue"),
        props: true,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: ":tournament_id/:tournament_name",
                name: "TournamentCompetitors",
                component: () =>
                    import(
                        "../components/Pages/Tournament/TabContent/TournamentCompetitors.vue"
                    ),
                props: true,
                meta: {
                    requiresAuth: true,
                    breadCrumb(route) {
                        const tournament_name = route.params.tournament_name;
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Соревнования",
                                to: { name: "TournamentsList" },
                            },
                            {
                                label: `${tournament_name}`,
                                to: { name: "TournamentCompetitors" },
                            },
                            {
                                label: "Участники",
                            },
                        ];
                    },
                },
            },
            {
                path: ":tournament_id/:tournament_name/sportsman/:id/:fio",
                name: "TournamentCompetitorProfile",
                component: () => import("../views/SportsmanProfileView"),
                props: true,
                meta: {
                    requiresAuth: true,
                    breadCrumb(route) {
                        const tournament_name = route.params.tournament_name;
                        const fio = route.params.fio;
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Соревнования",
                                to: { name: "TournamentsList" },
                            },
                            {
                                label: `${tournament_name}`,
                                to: { name: "TournamentCompetitors" },
                            },
                            {
                                label: "Участники",
                                to: { name: "TournamentCompetitors" },
                            },
                            {
                                label: `${fio}`,
                            },
                        ];
                    },
                },
            },
            {
                path: ":tournament_id/:tournament_name/format",
                name: "TournamentFormat",
                component: () =>
                    import(
                        "../components/Pages/Tournament/TabContent/TournamentFormat.vue"
                    ),
                props: true,
                meta: {
                    requiresAuth: true,
                    breadCrumb(route) {
                        const tournament_name = route.params.tournament_name;
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Соревнования",
                                to: { name: "TournamentsList" },
                            },
                            {
                                label: `${tournament_name}`,
                                to: { name: "TournamentCompetitors" },
                            },
                            {
                                label: "Формат",
                            },
                        ];
                    },
                },
            },
            {
                path: ":tournament_id/:tournament_name/groups",
                name: "TournamentGroups",
                component: () =>
                    import(
                        "../components/Pages/Tournament/TabContent/TournamentGroups.vue"
                    ),
                props: true,
                meta: {
                    requiresAuth: true,
                    breadCrumb(route) {
                        const tournament_name = route.params.tournament_name;
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Соревнования",
                                to: { name: "TournamentsList" },
                            },
                            {
                                label: `${tournament_name}`,
                                to: { name: "TournamentCompetitors" },
                            },
                            {
                                label: "Группы",
                            },
                        ];
                    },
                },
                children: [
                    {
                        path: ":grid_id",
                        name: "Group",
                        component: () =>
                            import(
                                "../components/Pages/Tournament/TabContent/TournamentGroup/index.vue"
                            ),
                        props: true,
                        meta: {
                            requiresAuth: true,
                        },
                        redirect: { name: "LineUpGroup" },
                        children: [
                            {
                                path: "lineup",
                                name: "LineUpGroup",
                                component: () =>
                                    import(
                                        "../components/Pages/Tournament/TabContent/TournamentGroup/TabContent/LineUpGroup.vue"
                                    ),
                                props: true,
                                meta: {
                                    requiresAuth: true,
                                },
                            },
                            {
                                path: "results",
                                name: "ResultsGroupGames",
                                component: () =>
                                    import(
                                        "../components/Pages/Tournament/TabContent/TournamentGroup/TabContent/ResultsGroupGames.vue"
                                    ),
                                props: true,
                                meta: {
                                    requiresAuth: true,
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: ":tournament_id/:tournament_name/grid/:grid_id",
                name: "TournamentGrid",
                component: () =>
                    import(
                        "../components/Pages/Tournament/TabContent/TournamentGrid.vue"
                    ),
                props: true,
                meta: {
                    requiresAuth: true,
                    breadCrumb(route) {
                        const tournament_name = route.params.tournament_name;
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Соревнования",
                                to: { name: "TournamentsList" },
                            },
                            {
                                label: `${tournament_name}`,
                                to: { name: "TournamentCompetitors" },
                            },
                            {
                                label: "Сетка",
                            },
                        ];
                    },
                },
            },
            {
                path: ":tournament_id/:tournament_name/total",
                name: "TournamentTotal",
                component: () =>
                    import(
                        "../components/Pages/Tournament/TabContent/TournamentTotal.vue"
                    ),
                meta: {
                    requiresAuth: true,
                    breadCrumb(route) {
                        const tournament_name = route.params.tournament_name;
                        return [
                            {
                                label: "Главная",
                                to: { name: "Home" },
                            },
                            {
                                label: "Соревнования",
                                to: { name: "TournamentsList" },
                            },
                            {
                                label: `${tournament_name}`,
                                to: { name: "TournamentCompetitors" },
                            },
                            {
                                label: "Итоги",
                            },
                        ];
                    },
                },
            },
        ],
    },
    {
        path: "/tournament/:tournament_id/:tournament_name/total/sportsman/:id/:fio",
        name: "CompetitorTotalProfilePage",
        component: () => import("../views/SportsmanProfileView.vue"),
        props: true,
        meta: {
            requiresAuth: true,
            breadCrumb(route) {
                const tournament_name = route.params.tournament_name;
                const fio = helper.getDecodeString(route.params.fio);
                return [
                    {
                        label: "Главная",
                        to: { name: "Home" },
                    },
                    {
                        label: "Соревнования",
                        to: { name: "TournamentsList" },
                    },
                    {
                        label: `${tournament_name}`,
                        to: { name: "TournamentCompetitors" },
                    },
                    {
                        label: "Итоги",
                        to: { name: "TournamentTotal" },
                    },
                    {
                        label: `${fio}`,
                    },
                ];
            },
        },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach(async (to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters["user/stateUser"]) {
            next();
        } else {
            try {
                await store.dispatch("user/REFRESH_LOGIN");
                next();
            } catch (e) {
                next("/login");
            }
        }
    } else {
        next();
    }
});

export default router;
